import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CodeInputModule } from 'angular-code-input';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RecaptchaModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';

import { MatDividerModule } from '@angular/material/divider';
import { ClipboardModule } from '@angular/cdk/clipboard';

import { FooterComponent } from './components/shared/footer/footer.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { CompletedConsentComponent } from './components/completed-consent/completed-consent.component';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ErrorInterceptor } from './_interceptors/error.interceptor';
import { LoadingInterceptor } from './_interceptors/loading.interceptor';
import { HomeComponent } from './components/home/home.component';
import { EndOfWorldComponent } from './components/end-of-world/end-of-world.component';
import { CustomeTranslateHttpLoader } from './services/translateHttpLoader';
import { MyMissingTranslationHandler } from './services/missing-translation.service';
import { OrderTranslatePipe } from './pipes/translate.sort.pipe';
import { LocalizedDatePipe } from './pipes/localizedDate.pipe';
import { PhoneFormatPipe } from './pipes/phone-format.pipe';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificationTileComponent } from './components/notifications/notification-tile/notification-tile.component';
import { MatCustomPaginatorIntl } from './services/mat-custome-paginator-intl';
import { NumbersOnlyDirectiveDirective } from './directives/numbers-only-directive.directive';

registerLocaleData(localeFr);

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// AoT requires an exported function for factories
// export function HttpLoaderFactory(http: HttpClient) {
//     return new TranslateHttpLoader(http);
// }
export function CustomeHttpLoaderFactory(http: HttpClient) {
  return new CustomeTranslateHttpLoader(http);
}
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    CompletedConsentComponent,
    EndOfWorldComponent,
    OrderTranslatePipe,
    LocalizedDatePipe,
    PhoneFormatPipe,
    NotificationsComponent,
    NotificationTileComponent,
    NumbersOnlyDirectiveDirective,
  ],
  imports: [
    CommonModule,
    MatDividerModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatExpansionModule,
    RecaptchaModule,
    MatTableModule,
    MatDialogModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatPaginatorModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    NgxSpinnerModule,
    ClipboardModule,
    MatRadioModule,
    MatTooltipModule,
    ScrollingModule,
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem('language') || 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: CustomeHttpLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
      },
      useDefaultLang: false,
    }),
    CodeInputModule,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
      },
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useFactory: (locale: string) => locale,
      deps: [LOCALE_ID],
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    { provide: MatPaginatorIntl, useClass: MatCustomPaginatorIntl },
    DatePipe,
    OrderTranslatePipe,
  ],
  //   bootstrap: [AppComponent],
  //  entryComponents: [],
  // ],
  //  providers: [],
  exports: [
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    CompletedConsentComponent,
    EndOfWorldComponent,
    OrderTranslatePipe,
    LocalizedDatePipe,
    PhoneFormatPipe,
    NotificationsComponent,
  ],
})
export class PathwaysUIModule {}